<input
  autocomplete="off"
  class="form-control"
  [type]="type || 'text'"
  [id]="id"
  [name]="name"
  [placeholder]="
    v3Input
      ? !(isFocused || value)
        ? placeholder || fieldValidationObject?.placeholder
        : ''
      : placeholder || fieldValidationObject?.placeholder
  "
  [class.validation-error]="validationError && !isFocused"
  [class.align-input]="alignInput"
  [class.input-tooltip]="inputTooltip"
  [class.barcode-input]="barCodeInput"
  [class.form-control-retail-plan]="isRetailPlan"
  [disabled]="disabled"
  [tabIndex]="tabindex"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledby"
  [required]="required"
  [(ngModel)]="value"
  [pattern]="pattern || fieldValidationObject?.allowedChars"
  [maxlength]="maxlength || fieldValidationObject?.fieldAttributes?.max"
  [minlength]="minlength || fieldValidationObject?.fieldAttributes?.min"
  (blur)="onBlur()"
  (focus)="onFocus()"
  (keydown)="onKeydown($event)"
  tmoAllowedInput
  tmoSetFocus
  tmoAutoFocus
  [autoFocus]="autoFocus"
  [ngClass]="{ 'w-100': type == 'search' }"
/>
<p
  *ngIf="isInputDirty && !isFocused && !hideInfieldErrorMessage"
  [class.error-label-search]="search"
  [class.text-ellipsis-message]="isEllipsis"
  [class.error-label-barcode]="barCodeInput"
  [class.error-label-barcode-tooltip]="barCodeInput && inputTooltip"
  class="small error-label"
>
  {{ validationErrorText }}
</p>
<p *ngIf="v3Input && (isFocused || value)" class="small placeholder truncate">
  {{ placeholder || fieldValidationObject?.placeholder }}
</p>
